import React from 'react';
import { Controller } from 'react-hook-form';
import { get, has } from 'lodash';

import DateTime from '../../DateTime';

function FormDate({
  control,
  errors,
  name,
  required = false,
  errorPath,
  defaultValue,
  ...props
}: any) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { ref, ...rest } }: any) => (
        <DateTime
          {...rest}
          inputRef={ref}
          helperText={get(errors, `${name}.message`) || get(errors, errorPath + '.message')}
          error={has(errors, name) || has(errors, errorPath)}
          required={required}
          {...props}
        />
      )}
    />
  );
}

export default FormDate;
